import { defineComponent } from 'vue';
import makeMoment from '@common/moment/MomentFactory';
import RequiredFields from '@common/layout/RequiredFields.vue';
import AffectedComponent from '../atoms/AffectedComponent.vue';
import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
import Reason from '../atoms/Reason.vue';
import EndDate from '../atoms/EndDate.vue';
import StartDate from '../atoms/StartDate.vue';
import { translator } from '~/zf/frontend/common/mixins';
import Duration from '../atoms/Duration.vue';
export default defineComponent({
    name: 'EditBody',
    compatConfig: {
        MODE: 3,
    },
    components: {
        RequiredFields,
        Duration,
        StartDate,
        EndDate,
        Reason,
        AffectedComponent,
    },
    mixins: [translator],
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
    },
    emits: ['update:model-value'],
    data() {
        return {
            BootstrapVariant,
            initialStart: this.modelValue.start,
        };
    },
    computed: {
        canEditFullDuration() {
            return makeMoment(this.initialStart) > makeMoment();
        },
    },
    methods: {
        updateDuration(update) {
            this.$emit('update:model-value', { ...this.modelValue, start: update[0], end: update[1] });
        },
    },
});
